const schedule = [
  {
    date: { day: "25 e 26", month: "JANEIRO", fulldate: "2025-01-25" },
    description: "Curso de primeiros socorros (interno)",
  },
  {
    date: { day: "15", month: "FEVEREIRO", fulldate: "2025-02-15" },
    description: "MPV Maringá-PR",
  },
  {
    date: { day: "22", month: "FEVEREIRO", fulldate: "2025-02-22" },
    description: "Culto na Bola de Neve Apucarana-PR",
  },
  {
    date: { day: "08", month: "MARÇO", fulldate: "2025-03-08" },
    description: "MPV Londrina-PR",
  },
  {
    date: { day: "22", month: "MARÇO", fulldate: "2025-03-22" },
    description: "MPV Ivaté-PR",
  },
  {
    date: { day: "12", month: "ABRIL", fulldate: "2025-04-12" },
    description: "MPV Jandaia do Sul-PR",
  },
  {
    date: { day: "18 à 21", month: "ABRIL", fulldate: "2025-04-18" },
    description: "Comitiva casais (Curitiba-PR)",
  },
  {
    date: { day: "01", month: "MAIO", fulldate: "2025-05-01" },
    description: "Motociata para Jesus",
  },
  {
    date: { day: "03", month: "MAIO", fulldate: "2025-05-03" },
    description: "Aniversário de 04 anos do RANCHEIROS MC",
  },
  {
    date: { day: "17", month: "MAIO", fulldate: "2025-05-17" },
    description: "MPV Arapongas-PR",
  },
  {
    date: { day: "14", month: "JUNHO", fulldate: "2025-06-14" },
    description: "MPV Cornélio Procópio-PR",
  },
  {
    date: { day: "19 à 22", month: "JUNHO", fulldate: "2025-06-19" },
    description: "Comitiva à definir",
  },
  {
    date: { day: "05", month: "JULHO", fulldate: "2025-07-05" },
    description: "MPV Maringá-PR",
  },
  {
    date: { day: "19", month: "JULHO", fulldate: "2025-07-19" },
    description: "MPV Apucarana-PR",
  },
  {
    date: { day: "23", month: "AGOSTO", fulldate: "2025-08-23" },
    description: "MPV Faxinal-PR",
  },
  {
    date: { day: "20", month: "SETEMBRO", fulldate: "2025-09-20" },
    description: "MPV Nova Esperança-PR",
  },
  {
    date: { day: "11", month: "OUTUBRO", fulldate: "2025-10-11" },
    description: "MPV Londrina-PR",
  },
  {
    date: { day: "08", month: "NOVEMBRO", fulldate: "2025-11-08" },
    description: "MPV Treinamento (interno)",
  },
  {
    date: { day: "06", month: "DEZEMBRO", fulldate: "2025-12-06" },
    description: "Confraternizações final de ano",
  },
];

export default schedule;
